const url = "http://63.35.252.151:8000"

export { url };